import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import ProjectReportsService from '../shared-services/project-reports.service'
import type { IProjectReportWebpageData } from '../shared-services/project-reports.model'
import { ProjectReportWebPage } from '../components/project-report-web-page'

export const ProjectReportPage = () => {
  const { id } = useParams()
  const projectReportsService = new ProjectReportsService()
  const [report, setReport] = useState<IProjectReportWebpageData>()

  useEffect(() => {
    if (id) {
      projectReportsService.getWebpage(id)
        .then(setReport)
        .catch(err => console.log(err))
    }
  }, [id])

  return (
    <Box style={{ width: '100%', height: '100%' }}>
      {report && <ProjectReportWebPage report={report} />}
    </Box>
  )
}
